angular.
module("dx.webapp.lti").
controller("DxExamPreviewRouteController", function ExamPreviewRouteController(
	$routeParams,
	$location,

	dxLtiRoute,
	Exam,
	ExamRepository,
	DX_URLS
) {
	"use strict";

	var self = this;

	this.exam = new Exam();
	this.questions = [];
	this.loading = true;

	var examId = $routeParams.examId || 0;

	this.dxLtiRoute = dxLtiRoute;

	ExamRepository.load(examId).then(function success(exam) {
		self.exam = exam;
		self.questions = angular.copy(self.exam.questions);
		self.loading = false;
	}, function failed() {
		$location.path(DX_URLS.get(404));
	});
});
